import clsx from 'clsx';

import useTitle from 'hooks/useTitle';
import { styled } from 'netline-ui';

import styles, { appHeaderTitleClasses, appHeaderTitleRootClasses } from './AppHeaderTitle.styles';

const AppHeaderTitleRoot = styled('div', { name: appHeaderTitleClasses.$name })(styles);

const AppHeaderTitle = () => {
  const { title, titleSvgUrl, titleSvgTooltip } = useTitle();

  if (titleSvgUrl) {
    return (
      <AppHeaderTitleRoot data-testid="AppHeaderTitle-root" className={appHeaderTitleClasses.root}>
        <div className={appHeaderTitleClasses.svgContainer}>
          <img
            className={appHeaderTitleClasses.titleSvg}
            src={titleSvgUrl}
            alt={titleSvgTooltip ?? title}
            title={titleSvgTooltip ?? title}
          />
        </div>
      </AppHeaderTitleRoot>
    );
  }

  return (
    <AppHeaderTitleRoot
      className={clsx(appHeaderTitleClasses.root, appHeaderTitleRootClasses.simple)}
      data-testid="AppHeaderTitle-root"
    >
      {title}
    </AppHeaderTitleRoot>
  );
};

export default AppHeaderTitle;
